<template>
  <div id="aboutus" class="c-content">
    <banner-general :content="banner"></banner-general>

    <image-block :content="imageBlock"></image-block>

    <team-work style='padding-top: 0' :content='teamwork'></team-work>

    <counsel-block></counsel-block>

    <case-block style='padding-top: 0'></case-block>

  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'
  import ImageBlock from '../layout/imageBlock.vue'
  import BannerGeneral from '../layout/bannerGeneral.vue'
  import CaseBlock from '../layout/caseBlock.vue'
  import CounselBlock from '../layout/counselBlock.vue'
  import TeamWork from '../layout/teamWork.vue'

  export default {
    name: 'aboutus',
    components: {
      'image-block': ImageBlock,
      'banner-general': BannerGeneral,
      'case-block': CaseBlock,
      'counsel-block': CounselBlock,
      'team-work': TeamWork
    },
    data(){
      return {
        aboutus: {
        },
        banner: {
          type: '1',
          img: require('../../assets/img/banner_aboutus.jpg'),
          title: this.$t('about_us.banner.title'),
          content: this.$t('about_us.banner.content'),
        },
        imageBlock: {
          img: require('../../assets/img/aboutus_01.png'),
          text:[
            {title: this.$t('about_us.image_block.title'), content: this.$t('about_us.image_block.content')},
          ]
        },
        teamwork: [
          {url: require('../../assets/img/logo_wibo.jpg'), bgUrl: require('../../assets/img/partner_wibo_pic.jpg'), shadowColor: "rgba(54, 54, 54, .56)", title: this.$t('team_work.theme_1.title'), content: this.$t('team_work.theme_1.content'), color: '#2B2B2B', contentColor:'#2B2B2B', bgColor: '#F3F3F3'},
          {url: require('../../assets/img/logo_pressalit.jpg'), bgUrl: require('../../assets/img/partner_pressalit_pic.jpg'), shadowColor: "rgba(31, 154,82, .45)", title: this.$t('team_work.theme_2.title'), content: this.$t('team_work.theme_2.content'), color: '#2B2B2B', contentColor:'#2B2B2B', bgColor: '#F3F3F3'},
          {url: require('../../assets/img/logo_dietz.jpg'), bgUrl: require('../../assets/img/partner_dietz_pic.jpg'), shadowColor: "rgba(54, 54, 54, .56)", title: this.$t('team_work.theme_3.title'), content: this.$t('team_work.theme_3.content'), color: '#2B2B2B', contentColor:'#2B2B2B', bgColor: '#F3F3F3'},
        ],
      }
    },
    computed: {

    },
    created () {
      if (this.getQueryVariable('anchor') == 'info') {
        this.scrollToInformation()
      }
    },
    methods: {
      getQueryVariable(variable) {
        let query
        if (window.location.href.indexOf('?') > -1) {
          query = window.location.href.split('?')[1]
        } else {
          query = ""
        }
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
      },
      scrollToInformation(){
        this.$nextTick(() => {
          setTimeout(() => {
            let errorHeight = document.querySelector('.c-counsel').getBoundingClientRect().y
            let scrollT = document.documentElement.scrollTop
            let h = scrollT + errorHeight - 90
            window.scroll({top:h,left:0,behavior:'smooth' })
          }, 500);
        });
      },
    },
  }
</script>

<style>

</style>
